// --- CSVincludes
// TODO: this feels like it should go somewhere else outside of utils/strings
// checks if comma-separated values list has specified value

export default function CSVIncludes ( csv, value ) {
    return !!csv.split( ", " )
        .find(
            ( currentValue ) => currentValue === value
        )
}